// extracted by mini-css-extract-plugin
module.exports = {"tabby-wrapper":"TabbyPromo_tabby-wrapper__7mjm5","custom-ui":"TabbyPromo_custom-ui__DoV6E","tabby-promo-container":"TabbyPromo_tabby-promo-container__qQD5u"};